import { Uint32BufferAttribute } from 'three';

export const cloudInstanceId = 0;
export const groundInstanceId = 65535;

/* Segmentation Mask headers
 * VERSION - Byte offset of 0, with a value of type Uint8
 * FLAGS - Byte offset of 1, with a value of type Uint24
 * LENGTH - Byte offset of 4, with a value of type Uint32
 * INSTANCE_ID - Byte offset 8, with a value of type Uint16
 */
const instanceIdValueOffset = 8;

// Casting to Uint32 so Threejs can map it to uint on WebGL
// https://threejs.org/docs/#api/en/core/Uniform
export function getInstanceIdsValues(content: ArrayBuffer) {
  return new Uint32BufferAttribute(getInstanceIdsTypedArray(content), 1);
}

function getInstanceIdsTypedArray(content: ArrayBuffer) {
  return new Uint16Array(content, instanceIdValueOffset);
}
